<section class="mh-home image-bg home-2-img" id="rdm-home">
    <div class="img-foverlay img-color-overlay">
        <div class="container">
            <div class="row section-separator xs-column-reverse
                vertical-middle-content home-padding">
                <div class="col-sm-6">
                    <div class="mh-header-info">
                        <div class="mh-promo wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.1s">
                            <span>Olá, eu sou o</span>
                        </div>

                        <h2 class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s">Raynner D. Matos</h2>
                        <h4 class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.3s">Senior Software & Gen AI Engineer</h4>

                        <ul>
                            <li class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s"><i
                                    class="fa fa-envelope"></i><a href="mailto:">raynner&#64;outlook.com</a></li>
                            <li class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"><i
                                    class="fa fa-phone"></i><a href="callto:">+55 (11) 99349-8646</a></li>
                            <li class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.6s"><i class="fa
                                    fa-map-marker"></i>
                                <address>
                                    São Paulo, Brasil
                                </address>
                            </li>
                        </ul>

                        <ul class="social-icon wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.7s">
                            <li>
                                <a href="https://medium.com/@raynnerdm" target="_blank">
                                    <i class="fa fa-medium"></i></a>
                            </li>
                            <li>
                                <a href="https://github.com/raynnerdm" target="_blank">
                                    <i class="fa fa-github"></i></a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/in/raynnerdm/" target="_blank">
                                    <i class="fa fa-linkedin"></i></a>
                            </li>
                            <li>
                                <a href="https://www.facebook.com/raynnerdm" target="_blank">
                                    <i class="fa fa-facebook"></i></a></li>
                            <li>
                                <a href="https://www.instagram.com/raynnerdm" target="_blank">
                                    <i class="fa fa-instagram"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="hero-img wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.6s">
                        <div class="img-border">
                            <img src="../../assets/images/hero.jpg" alt="" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>